import React, { useState, useEffect } from 'react';
import { devError } from '../../lib/devLog';
import { motion } from 'framer-motion';
import axios from 'axios';
import { Plus, Edit, Trash2, Image as ImageIcon, Check } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const GalleryManager = () => {
  const { token } = useAuth();
  const [galleries, setGalleries] = useState([]);
  const [artworks, setArtworks] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingGallery, setEditingGallery] = useState(null);
  const [selectedArtworks, setSelectedArtworks] = useState([]);
  
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    artworkIds: [],
    featured: false,
    startDate: '',
    endDate: '',
    location: 'Zebra One Gallery, Hampstead'
  });

  useEffect(() => {
    fetchGalleries();
    fetchArtworks();
  }, []);

  const fetchGalleries = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/galleries`);
      setGalleries(response.data);
    } catch (error) {
      devError('Error fetching galleries:', error);
    }
  };

  const fetchArtworks = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/artworks?include_hidden=1`);
      setArtworks(response.data);
    } catch (error) {
      devError('Error fetching artworks:', error);
    }
  };

  const toggleArtworkSelection = (artworkId) => {
    setSelectedArtworks(prev =>
      prev.includes(artworkId)
        ? prev.filter(id => id !== artworkId)
        : [...prev, artworkId]
    );
  };

  const resetForm = () => {
    setFormData({
      name: '',
      description: '',
      artworkIds: [],
      featured: false,
      startDate: '',
      endDate: '',
      location: 'Zebra One Gallery, Hampstead'
    });
    setSelectedArtworks([]);
    setEditingGallery(null);
    setShowForm(false);
  };

  return (
    <div className="p-8">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-4xl font-light mb-2">Galleries</h1>
          <p className="text-gray-600">Create curated collections</p>
        </div>
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => setShowForm(!showForm)}
          className="px-6 py-3 bg-black text-white rounded-lg flex items-center gap-2"
        >
          <Plus className="w-5 h-5" />
          Create Gallery
        </motion.button>
      </div>

      <div className="text-center py-12 text-gray-500">
        <ImageIcon className="w-16 h-16 mx-auto mb-4 opacity-20" />
        <p>Gallery manager coming soon</p>
      </div>
    </div>
  );
};

export default GalleryManager;
